<template>
  <v-navigation-drawer
    app
    clipped
    v-model="menuIsOpen"
    :width="sidebarWidth"
    
    :mini-variant-width="sidebarMinWidth"
    >

    <div class="v-list">
      <a class="v-list-item v-list-item--link grey--text text-sm-h6" target="_blank" @click="goTo('/homeVIew')">Dashboard</a>
    </div>

    <v-list>
      <template v-for="(item, i) in items">

        <v-list-item
          color="primary"
          v-if="userType === 'Administrador' || (userType.includes('Técnico') && item.title === 'Equipos')"
          :key="i"
          :href="item.href ? item.href : null"
          :to="item.link === '#' ? null : item.link"
          link>
          <v-list-item-action>
            <v-icon
              size="28"
              :color="item.color ? item.color : ''"
            >{{ item.icon }}</v-icon>
          </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                class="grey--text"
                link>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapState} from 'vuex'
// import EquipoStore from "@/store/index";

  export default {
    props: {
        source: String,
        menuIsOpen: {
      type: Boolean,
      required: true,
    },
  //   userType: {
  //   type: String,
  //   required: true,
  // },
    },
      
    data(){
      return {
        items: [
          { title: 'Optix', icon: 'mdi-alpha-o-circle', link: '/optix' },
          { title: 'Westnet', icon: 'mdi-alpha-w-box', link: '/westnet' },
          { title: 'Bigway', icon: 'mdi-alpha-b-box', link: '/bitway' },
          { title: 'Registro de usuarios', icon: 'mdi-account-multiple', link: '/registerView' },
          { title: 'Técnicos', icon: 'mdi-account-hard-hat-outline', link: '/tecnicos' },
          { title: 'Totales', icon: 'mdi-format-size', link: '/totales' },
          { title: 'Asignar Equipos', icon: 'mdi-router-wireless', link: '/equiposView' },
          { title: 'Equipos', icon: 'mdi-router-wireless', link: '/equiposTecnicos' },


        ],
        sidebarWidth: 240,
        sidebarMinWidth: 96,
        drawer: false,
        // userType: EquipoStore.data.userType,
        
      }
    },

    computed: {
      ...mapState({
         userType: state => state.userType,
         userEmpresa: state => state.userEmpresas,
      }),
      // DRAWER_STATE: {
      //   get() {
      //     return this.drawer
      //   },
      //   set(newValue) {
      //     if (newValue === this.drawer) return;
      //     this.TOGGLE_DRAWER();
      //   }
      // }
    },
    created() {
      // this.userType = EquipoStore.data.userType
      console.log("tipo usuario",this.userType)
    },
    methods: {
      // ...mapActions([ 'TOGGLE_DRAWER' ]),
      goTo(link) {
      this.$router.push(link);
    },
    }
  }
</script>


<style src="./Sidebar.scss" lang="scss"/>